import React, { useState } from "react";
import EditPackageComponent from "../../components/EditPackage";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNotification } from "../../../../../context/NotificationProvider";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import {
  getPackageDetail,
  putPackage,
} from "../../../../../services/Handlers/MasterPackageService";
import { useHistory } from "react-router-dom";
import { getParams } from "../../../../../utils/utils";
import LoadingSection from "../../../../components/LoadingSection";

export default function EditPackage() {
  const notification = useNotification();
  const localize = useLocalization();
  const history = useHistory();
  const id = getParams("id");

  const [initialValues, setInitialValues] = useState({});

  const { isLoading, isFetching } = useQuery(
    ["PackageDetail"],
    () => getPackageDetail(id),
    {
      enabled: !!id,
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          const response = res.data;
          if (response) {
            const transformedItems = response?.items?.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            setInitialValues({
              name: response.name,
              price: response.price,
              numberOfVisit: response.number_of_visit,
              packageItems:
                transformedItems.length > 0 ? transformedItems : [""],
              active: response.active !== false,
            });
          }
        }
      },
    }
  );

  const { isLoading: isLoadingSubmit, mutate: mutateSubmit } = useMutation(
    putPackage,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successEditData"));
          history.goBack();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: (res) => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  const handleSubmit = (value) => {
    const data = {
      name: value.name,
      price: value.price,
      number_of_visit: value.numberOfVisit,
      items:
        (value.packageItems.every((item) => !!item.value) &&
          value.packageItems.map((item) => item.value)) ||
        [],
      id,
      active: value.active !== false,
    };
    mutateSubmit(data);
  };

  if (isLoading || isFetching) {
    return <LoadingSection />;
  }

  return (
    <EditPackageComponent
      handleSubmit={handleSubmit}
      isLoadingSubmit={isLoadingSubmit}
      initialValues={initialValues}
    />
  );
}
